import { apiClient } from "../apiClient";

export default function getGlossaryById(glossaryId) {
  return apiClient.get(`glossary/${glossaryId}`);
}
